import React, { ForwardedRef, RefObject, useMemo, useRef } from "react";
import { VideoPlayerRefsContext } from ".";

interface RefProps {
  children: React.ReactNode;
  forwardedRef?: ForwardedRef<HTMLVideoElement>;
}

export const VideoPlayerRefsProvider = ({
  children,
  forwardedRef,
}: RefProps) => {
  const video = useRef<HTMLVideoElement>(null);
  const container = useRef<HTMLDivElement>(null);
  const overlay = useRef<HTMLDivElement>(null);
  const controlBar = useRef<HTMLDivElement>(null);
  const seekBar = useRef<HTMLDivElement>(null);

  const value = useMemo(
    () => ({
      video: (forwardedRef as RefObject<HTMLVideoElement>) ?? video,
      controlBar,
      seekBar,
      container,
      overlay,
    }),
    [forwardedRef]
  );

  return (
    <VideoPlayerRefsContext.Provider value={value}>
      {children}
    </VideoPlayerRefsContext.Provider>
  );
};
